module.exports = __webpack_public_path__ + "img/a_t_capital.736efc6f.png";